import Vue from "vue";// 引入vue
import Router from "vue-router";// 引入vue-router
Vue.use(Router);// 使用路由
const originalPush = Router.prototype.push;
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

// import home from "@/views/home/index"
import newHome from "@/views/new_home/index"
import partner from "@/views/new_home/partner"
import product from "@/views/product/index"
import app from "@/views/app_dowload/index"
import coopSettlement from "@/views/coop_Settlement/index"
import aboutUs from "@/views/about_us/index"
import newsDetail from "@/views/newsDetail/news.vue"
import brand from "@/views/brand/index"
import recruitDetail from "@/views/about_us/components/RecruitDetail"
//引入新闻中心页面
import newsCenter from "@/views/newsCenter"
import companyNews from "@/views/newsCenter/companyNews"
import industryNews from "@/views/newsCenter/industryNews"
//引入新闻中心新闻的详情页面
import newsCenterDetail from "@/views/newsCenterDetail/index"
import newaboutus from "@/views/newaboutus/index"
import culture from "@/views/newaboutus/culture"
import contact from "@/views/newaboutus/contact"
// import newSolution from "@/views/newSolution/index"
// import newProduct from "@/views/newProduct/index"
import newJoinus from "@/views/newJoinus/index"
import newJoinusSocialRecruit from "@/views/newJoinus/socialRecruit/index"
import positionInfo from "@/views/newJoinus/positionInfo/index"
import ecologicalSolution from "@/views/newSolution/ecologicalSolution"
import operationSolution from "@/views/newSolution/operationSolution"
import projectSolution from "@/views/newSolution/projectSolution"

//产品模块页面
import productCistanche from "@/views/product/productCistanche"
import projectApp from "@/views/product/projectApp"
import productPatient from "@/views/product/productPatient"
import productPharmacy from "@/views/product/productPharmacy"

import mobilehome from "@/views/mobile/home"
import mobilePartner from "@/views/mobile/partner"
import mobileaboutUs from "@/views/mobile/groupIntroduce"
import mobileculture from "@/views/mobile/culture"
import mobileContact from "@/views/mobile/contact"
import mobileProjectApp from '@/views/mobile/product/projectApp'
import mobileCistanche from '@/views/mobile/product/productCistanche'
import mobileProductPatient from '@/views/mobile/product/productPatient'
import mobileProductPharmacy from '@/views/mobile/product/productPharmacy'
import developing from '@/views/mobile/developing'
import mobileNewsCenter from "@/views/mobile/news/center.vue"
import mobileNewsDetail from "@/views/mobile/news/detail.vue"
import mobileNewsCompany from "@/views/mobile/news/companyNews.vue"
import mobileNewsIndustry from "@/views/mobile/news/industryNews.vue"
import mobileOperation from '@/views/mobile/solution/operation'
import mobileProject from '@/views/mobile/solution/project'
import mobileEcological from '@/views/mobile/solution/ecological'
import mobileRecruit from '@/views/mobile/joinUs/recruit.vue'
import mobileRecruitDetail from '@/views/mobile/joinUs/recruitDetail.vue'
import mobileJoinus from '@/views/mobile/joinUs/index'

//引入升级中页面
// import upGrading from "@/views/Upgrading/index"


const router = new Router({// 实例化router对象
    mode:"history",// 使用hash路由，带#号
    routes:[// 路由的配置项
        {
            path: '/',
            redirect: '/home'
        },// 首页组件
        {
            path:"/home",
            component: newHome
        },// 首页组件
        {
            path:"/partner",
            component: partner
        },
        {
            path:"/product/:id",
            component:product
            // 产品组件
        },
        {
            path:"/app/:id",
            component:app
            // app下载组件
        },
        {
            path:"/coopSettlement/:id",
            component:coopSettlement
            // 合作入驻组件
        },
        {
            path:"/aboutUs/:id",
            component:aboutUs,
            // 合作入驻组件
        },
        {
            path:"/newsdetail/:id",
            component:newsDetail
        },
        {
            path:"/brand",
            component:brand
        },
        {
            path:'/recruidetail',
            component:recruitDetail
        },
        {
            path:'/newsCenter',
            component:newsCenter
        },
        {
            path:'/newsCenterDetail/:id',
            component:newsCenterDetail
        },
        {
            path:'/product',
            component:productCistanche
        },
        {
            path:'/projectApp',
            component:projectApp
        },
        {
            path:'/productPatient',
            component:productPatient
        },
        {
            path:'/productPharmacy',
            component:productPharmacy
        },
        // {
        //     path:'/Solution',
        //     component:newSolution
        // },
        {
            path: '/aboutUs',
            component: newaboutus,
        },
        {
            path:'/culture',
            component: culture,
        },
        {
            path: '/contact',
            component: contact,
        },
        {
            path:'/joinUs',
            component: newJoinus
        },
        {
            path:'/joinUs_mobile',
            component: mobileJoinus
        },
        {
            path:'/socialRecruit',//社招
            component: newJoinusSocialRecruit
        },
        {
            path:'/positionInfo',//职位详情
            component: positionInfo
        },
        {
            path:'/ecologicalSolution',
            component:ecologicalSolution
        },
        {
            path:'/operationSolution',
            component:operationSolution
        },
        {
            path:'/projectSolution',
            component:projectSolution
        },

        {
            path:'/aboutUs_mobile',
            component: mobileaboutUs
        },
        {
            path:'/culture_mobile',
            component: mobileculture
        },
        {
            path:'/home_mobile',
            component: mobilehome
        },
        {
            path:'/partner_mobile',
            component: mobilePartner
        },
        {
            path: '/contact_mobile',
            component: mobileContact
        },
        {
            path: '/projectApp_mobile',
            component: mobileProjectApp
        },
        {
            path: '/projectSolution_mobile',
            component: mobileProject
        },
        {
            path: '/mobileEcological_mobile',
            component: mobileEcological
        },
        {
            path: '/product_mobile',
            component: mobileCistanche
        },
        {
            path: '/productPatient_mobile',
            component: mobileProductPatient
        },
        {
            path: '/productPharmacy_mobile',
            component: mobileProductPharmacy
        },
        {
            path: '/operationSolution_mobile',
            component: mobileOperation
        },
        {
            path: '/developing_mobile',
            component: developing
        },
        {
            path: '/news/center_mobile',
            component: mobileNewsCenter
        },
        {
            path: '/news/detail_mobile/:id',
            component: mobileNewsDetail,
        },
        {
            path: '/recruit_mobile',
            component: mobileRecruit,
        },
        {
            path: '/recruitDetail_mobile/:id',
            component: mobileRecruitDetail,
        },
        {
            path:"/companyNews",
            component: companyNews
        },
        {
            path:"/industryNews",
            component: industryNews
        },
        { 
            path:"/companyNews_mobile",
            component: mobileNewsCompany
        },
        {
            path:"/industryNews_mobile",
            component: mobileNewsIndustry
        }
    ]
});
const isMobile = () => {
	if (document.documentElement.clientWidth / window.devicePixelRatio >= 640) {
		return false
	}
	// console.log(navigator.userAgent)
	if (navigator.userAgent.indexOf('Mobile')>-1) {
		// console.log('is Mobile')
		return true
	}
	if ((navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i))) {
		// console.log('is Mobile')
		return true // 手机端
	} else {
		// console.log('is NOT Mobile')
		return false // alert('PC端')
	}
}
router.beforeEach((to, from, next) => {
    if(isMobile()) {
        let pathArr = to.path.split('_')
        if(pathArr.length > 1) {
            next()
        } else {
            next(`${to.path}_mobile`)
        }
    } else {
        let pathArr = to.path.split('_')
        if(pathArr.length > 1) {
            next(pathArr[0])
        } else {
            next()
        }
    }
})
export default router;// 抛出路由
